/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
import {
    NOTIFY,
    FETCH_DATA,
    FETCH_COMPLETE
} from './types';
import { APPLICABLE_INVOICE_ITEMS } from '../../data/selects';
import { customers, customsHouses, users, customerTabularPriceses, expensesTabularPriceses, invoiceItems } from '../../services';

const services = {
    customers,
    customsHouses,
    users,
    customerTabularPriceses,
    expensesTabularPriceses,
    invoiceItems
};

//TODO params (service, stateProperty, URL, paramas)
export const fetchData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        console.log(service, path, url);
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path: 'numPages', value: result.page.totalPages },
                  { path: 'activePage', value: result.page.number },
                  { path, value: result._embedded.customers },
                  { path: 'isLoading', value: false }
              ]);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchformData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path, value: result._embedded.customerTabularPriceses },
                {path: 'isLoading', value: false}
            ]);
          }else {
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
    };
};

export const fetchExpensesData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path, value: result._embedded.expensesTabularPriceses },
                {path: 'isLoading', value: false}
            ]);
          }else {
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
    };
};

export const fetchCustomsHousesData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        console.log(service);
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path, value: result._embedded.customsHouses },
                  { path: 'isLoading', value: false }
              ]);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchExecutiveUsersData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  {
                      path,
                      value: {
                          items: result._embedded.users.map((user) => {
                              return {
                                  id: '/users/' + user._links.self.href.substr(user._links.self.href.lastIndexOf('/') + 1),
                                  name: user.name
                              };
                          }),
                          displayProp: (item) => item.name
                      }
                  },
                  { path: 'isLoading', value: false }
              ]);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};


const onDataLoaded = (dispatch, targets) => {
    dispatch({
        type: NOTIFY,
        payload: { op: 'multiUpdate', targets }
    });
};

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};


export const saveCustomer = (newCustomer) => {
    newCustomer = {
        ...newCustomer,
        address: {
            street: newCustomer.street,
            externalNumber: newCustomer.externalNumber,
            internalNumber: newCustomer.internalNumber,
            zipCode: newCustomer.zipCode,
            colony: newCustomer.colony,
            city: newCustomer.city,
            state: newCustomer.state,
            country: newCustomer.country,
            municipality: newCustomer.municipality
        }
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customers"].post("customers?projection=denormalizedCustomer", newCustomer).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado nuevo cliente a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'customers', value: result } });
            }else {
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
                showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

const getJSON = (TabularInformation) =>{
  if(TabularInformation.checkedTypeFLAT === true){
    const customerTabularPriceses = {
       tabularType: "FLAT",
       importFee: 0,
       minimumImportFee: 0,
       complementaryImportCharge: 0,
       exportFee: 0,
       minimumExportFee: 0,
       complementaryExportCharge: 0,
       flatImportFee: TabularInformation.importacionFlat.tarifa,
       flatExportFee: TabularInformation.exportacionFlat.tarifa,
       customer: {
         id: TabularInformation.customer
       },
       customsHouse: {
         id: TabularInformation.aduana
       },
       currency: TabularInformation.moneda
    }

    return customerTabularPriceses;
  }else {
    const customerTabularPriceses = {
       tabularType: "REGULAR",
       importFee: TabularInformation.importacion.porcentaje,
       minimumImportFee: TabularInformation.importacion.caja,
       complementaryImportCharge: TabularInformation.importacion.contenedor,
       exportFee: TabularInformation.exportacion.porcentaje,
       minimumExportFee: TabularInformation.exportacion.caja,
       complementaryExportCharge: TabularInformation.exportacion.contenedor,
       flatImportFee: 0,
       flatExportFee: 0,
       customer: {
         id: TabularInformation.customer
       },
       customsHouse: {
         id: TabularInformation.aduana
       },
       currency: TabularInformation.moneda
    }

    return customerTabularPriceses;
  }

};

export const saveTabularPriceses = (newTabularPriceses) => {

  const firsSection = getJSON(newTabularPriceses);
  var expensesTabularPriceses = [];

    for(var  i = 0; i< newTabularPriceses.gastos.length; i++){
          expensesTabularPriceses.push({
              invoiceItem: {
                id: newTabularPriceses.gastos[i].concepto.id
              },
              priceValue: newTabularPriceses.gastos[i].precio,
              expenseType: "Gastos aplicables"
            }
          );
    }

    for(var  i = 0; i< newTabularPriceses.gastosOpcionales.length; i++){
            expensesTabularPriceses.push({
                invoiceItem: {
                  id: newTabularPriceses.gastosOpcionales[i].concepto.id
                },
                priceValue: newTabularPriceses.gastosOpcionales[i].precio,
                expenseType: "Gastos opcionales"
              }
            );
    }

    newTabularPriceses={
      ...firsSection,
      expensesTabularPricesList: expensesTabularPriceses
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customerTabularPriceses"].post("customerTabular/saveCustomerTabularForForm", newTabularPriceses).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path: 'isLoading', value: false }
            ]);
          }else {
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
      };
};

export const saveInvoiceItem = (newInvoiceItem) => {

  for(var i=0; i < APPLICABLE_INVOICE_ITEMS.items.length; i++)
  {
    if(APPLICABLE_INVOICE_ITEMS.items[i].id === newInvoiceItem.applicable){
      newInvoiceItem = {
        ...newInvoiceItem,
        applicableRepresentation: APPLICABLE_INVOICE_ITEMS.items[i].name
      }
    }
  }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["invoiceItems"].post("invoiceItems", newInvoiceItem).then(result => {
            if(typeof(result.response) === "undefined"){
                  //Cierro modal de formulario
                  dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'conceptoOpen', value: false } });
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const editCustomer = (editedCustomer, index) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customers"].patch("customers/" + editedCustomer.id + "?projection=denormalizedCustomer", editedCustomer).then(result => {
            if(typeof(result.response) === "undefined"){
              //Añado nuevo cliente a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'customers', value: { index, value: result } } });
            }else {
                showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const editTabularPriceses = (newTabularPriceses) => {

  const firsSection = getJSON(newTabularPriceses);
  var expensesTabularPriceses = [];

    for(var  i = 0; i< newTabularPriceses.gastos.length; i++){
      if(newTabularPriceses.gastos[i].useLabel === true){
          expensesTabularPriceses.push({
              id:newTabularPriceses.gastos[i].id,
              invoiceItem:{ id: newTabularPriceses.gastos[i].concepto.id},
              priceValue: newTabularPriceses.gastos[i].precio,
              expenseType: "Gastos aplicables"
            }
          );
        }else {
          expensesTabularPriceses.push({
              invoiceItem:{ id: newTabularPriceses.gastos[i].concepto.id },
              priceValue: newTabularPriceses.gastos[i].precio,
              expenseType: "Gastos aplicables"
            }
          );
        }
    }


    for(var  i = 0; i< newTabularPriceses.gastosOpcionales.length; i++){
        if(newTabularPriceses.gastosOpcionales[i].useLabel === true){
            expensesTabularPriceses.push({
                id: newTabularPriceses.gastosOpcionales[i].id,
                invoiceItem:{id:newTabularPriceses.gastosOpcionales[i].concepto.id},
                priceValue: newTabularPriceses.gastosOpcionales[i].precio,
                expenseType: "Gastos opcionales"
              }
            );
          }else {
            expensesTabularPriceses.push({
                invoiceItem:{ id:newTabularPriceses.gastosOpcionales[i].concepto.id },
                priceValue: newTabularPriceses.gastosOpcionales[i].precio,
                expenseType: "Gastos opcionales"
              }
            );
          }
    }

    newTabularPriceses={
      id: newTabularPriceses.id,
      ...firsSection,
      expensesTabularPricesList: expensesTabularPriceses
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customerTabularPriceses"].post("customerTabular/updateCustomerTabularForForm/", newTabularPriceses).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path: 'isLoading', value: false }
            ]);
          }else {
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
      };
};

const showErrorMessage = (dispatch, message)  => {
  onDataLoaded(dispatch, [
      { path: 'isLoading', value: false },
      { path: 'showNotification', value: true},
      { path: 'showMessage', value:   message },
      { path: 'notificationColor', value: 'red' }
  ]);
};

const saveExpensesTabular = (expensesTabular, id, expenseType) => {
  const customExpensesTabular = {
    invoiceItem: "/invoiceItem/" + expensesTabular.concepto.id,
    priceValue: expensesTabular.precio,
    customerTabular: "/customerTabularPrices/" + id,
    expenseType: expenseType
  }

        return services["expensesTabularPriceses"].post("expensesTabularPriceses", customExpensesTabular).then(result => {
        });
};

export const deleteCustomer = (CustomerToRemove, index) =>{
  return (dispatch) => {
      dispatch({ type: FETCH_DATA });
      return services['customers'].Delete('customers/'+ CustomerToRemove.id).then(result => {
          onDataLoaded(dispatch, [
              { path: 'isLoading', value: false },
              { path: 'showNotification', value: true},
              { path: 'showMessage', value: result.message },
              { path: 'notificationColor', value: result.color }
          ]);
          if(result.color=== '#04B404'){
            dispatch({ type: FETCH_COMPLETE, payload: { op: 'remove', path: 'customers', value: index } });
          }
      });
  };
};



// WEBPACK FOOTER //
// ./containers/clientes/actions.js